import fetchApi from '../util/fetchApi';
import checkErrors from './checkErrors';
import { WFAccessToken } from './types';

const getAccessTokenHeaders = wfAccessToken => {
  if (!wfAccessToken) return {};

  return {
    headers: {
      'Workflow-Token': wfAccessToken?.hash,
    },
  };
};

export const FileApi = {
  async uploadFile({ file, entityId, wfAccessToken }: { file: File; entityId?: number; wfAccessToken?: WFAccessToken }) {
    const options = {
      ...getAccessTokenHeaders(wfAccessToken),
      formdata: {
        file,
        ...(entityId && { UWEEntityId: entityId }),
        ...(wfAccessToken?.id && { workflowAccessTokenId: wfAccessToken.id }),
      },
    };

    return checkErrors(await fetchApi.api.post('uploaded-file', options));
  },

  async getFile({ fileId, wfAccessToken }: { fileId: number; wfAccessToken?: WFAccessToken }) {
    const options = { ...getAccessTokenHeaders(wfAccessToken) };

    return checkErrors(await fetchApi.api.get(`uploaded-file/${fileId}`, options));
  },

  async getFileUrl({ fileId, wfAccessToken }: { fileId: number; wfAccessToken?: WFAccessToken }): Promise<string | null> {
    const options = { ...getAccessTokenHeaders(wfAccessToken) };

    return checkErrors(await fetchApi.api.get(`uploaded-file/${fileId}/url`, options));
  },

  async getFileByReferenceId({ referenceId, wfAccessToken }: { referenceId: number | string; wfAccessToken?: WFAccessToken }) {
    const options = { ...getAccessTokenHeaders(wfAccessToken) };

    return checkErrors(await fetchApi.api.get(`uploaded-file/reference/${referenceId}`, options));
  },
};

export default FileApi;
